import ProbaWorkflowsSidebar from '@/components/probaworkflows_base_components/ProbaWorklfowsSidebar/ProbaWorkflowsSidebar.vue'; // Use PascalCase
import { GET_ALL_PERMISSIONS, get_headers } from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import axios from 'axios';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import $ from 'jquery';
import Swal from 'sweetalert2';
 
export default {
  name: 'PermissionManagement',
  components: {
    ProbaWorkflowsSidebar,
    GlobalTable
  },
  mixins: [alert_mixin],
  data: () => ({
    permissions: [],
    headers: '',
    selected_main_feature: null,
    selected_sub_feature: null,
    features: [
      { name: 'Compliance', expanded: false },
      { name: 'System configuration', expanded: false },
      { name: 'Customer management', expanded: false },
    ],
    user_permissions: [
      'User', 'Add user', 'Deactivate user access', 'Update user', 'Update UserRole',
    ],
    role_permissions: [
      'Roles', 'Create roles', 'Update roles', 'Delete roles',
    ],

    // Hardcoded table preview data
    permission_list: [
      { id: 1, policy_name: 'For Her Education', description: '20-05-2024' },
      { id: 2, policy_name: 'For Her Education', description: '31-07-2023' },
      { id: 3, policy_name: 'For Her Education', description: '11-01-2024' }
    ],
    permission_table: 'permission-table'
  }),
  mounted() {
    this.headers = get_headers();
    this.get_all_permissions();
    this.initialize_table();
  },
  methods: {
    assign_features() {
      this.$router.push('/assigning_permissions');
    },
     delete_policy() {
                Swal.fire({
                  title: "Are you sure you want to delete?",
                  text: "You won't be able to revert this!",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#d33",
                  cancelButtonColor: "#3085d6",
                  confirmButtonText: "Yes, delete it!"
                }).then((result) => {
                  if (result.isConfirmed) {
                    Swal.fire("Deleted!", 'The action has been deleted.');
                  }
                });
              },
    get_all_permissions() {
      axios.get(GET_ALL_PERMISSIONS, { headers: this.headers })
        .then(response => {
          // Parse API response and store data; your API response JSON structure puts the permission items in "data"
          this.permissions = JSON.parse(response.data).data;
          this.initialize_table();
        })
        .catch(error => {
          this.show_error("Error fetching permissions:", error);
        });
    },
    initialize_table() {
      this.$nextTick(() => {
        if ($.fn.DataTable.isDataTable('#permission-table')) {
          $('#permission-table').DataTable().destroy();
        }
        $('#permission-table').DataTable();
      });
    },
    go_back_to_company_management() {
      this.$router.push('/company_management');
    }
  },
};